<template>
  <div class="cta-block">
    <Loader v-if="!group.name" />
    <div v-if="group.name" class="block-wrapper">
      <div class="block-content">
        <strong>GROUP</strong>
        <h2>{{ group.name }}</h2>
        <p>{{ group.description }}</p>
        <h3>{{ projectCount }} projects</h3>
        <h3 v-if="group.role !== 'Member'">
          {{ $t("plan.groupBlock.members", { num: memberCount }) }}
        </h3>
        <p v-if="group.role !== 'Member'">
          {{ $t("plan.groupBlock.creditsMeter") }}:
          <strong>{{ meterType() }}</strong>
        </p>
        <p v-if="group.role !== 'Member'">
          {{ $t("plan.groupBlock.creditsAvailable") }}:
          <strong>{{
            isUnlimitedCredit ? $t("plan.groupBlock.unlimited") : wsCredits
          }}</strong>
        </p>
      </div>

      <div class="block-foot">
        <router-link
          v-if="planAdmin || (planEnabled && group.enabled)"
          class="button light"
          v-bind:to="'/group/' + group.id"
          >{{ $t("plan.groupBlock.button.open") }}</router-link
        >
        <a v-else class="button dark">{{
          $t("plan.groupBlock.button.archived")
        }}</a>
        <router-link
          v-if="group.role !== 'Member'"
          class="history"
          v-bind:to="'/group/' + group.id + '/history'"
          >{{ $t("plan.groupBlock.link.history") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import { groupService } from "@/services/group.service";

export default {
  props: ["group", "credits", "planAdmin", "planEnabled", "isUnlimitedCredit"],
  name: "GroupBlock",
  components: {
    Loader,
  },
  data() {
    return {
      wsCredits: this.credits,
      projectCount: 0,
      memberCount: 0,
    };
  },
  created: function () {
    if (this.group.role !== "Member") {
      this.getMembers();
    }

    this.getProjects();
  },
  methods: {
    meterType: function () {
      if (this.group.meterActive) {
        this.getOwnCreds();

        return this.$t("plan.groupBlock.meterType.own");
      } else {
        return this.$t("plan.groupBlock.meterType.parent");
      }
    },
    getOwnCreds: function () {
      groupService
        .getMeter(this.group.id)
        .then((meter) => {
          this.wsCredits = meter.currentValue;
        })
        .catch((err) => {
          console.error("Unable to get group meter: ", err);
        });
    },
    getMembers: function () {
      groupService
        .getMembers(this.group.id)
        .then((members) => {
          this.memberCount = members.length;
        })
        .catch((err) => {
          console.error("Unable to get group members: ", err);
        });
    },
    getProjects: function () {
      groupService
        .getProjects(this.group.id)
        .then((projects) => {
          this.projectCount = projects.length;
        })
        .catch((err) => {
          console.error("Unable to get projects: ", err);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.cta-block {
  margin-bottom: 20px;
  flex: 0 1 24%;

  .block-wrapper {
    height: 100%;
    background-color: $text-alpha;
    color: $text-light;
    padding: 12px;
    margin-right: 20px;
    display: flex;
    flex-direction: column;
  }
}

a {
  color: $secondary;
  text-decoration: underline;
}

h2 {
  color: $secondary;
  font-weight: $semi-bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

h3 {
  color: $text-light;
}

.history {
  margin-top: 17px;
  line-height: 30px;
  float: right;
}

.block-content {
  flex: 1 0 auto;
}

.block-foot {
  flex: 0 1 auto;
}
</style>
